<div class="cmn__autocomplete">
    <p-autoComplete 
        appendTo="body"
        [disabled] = "_disable"
        [(ngModel)]="selectedItem" 
        [suggestions]="filteredItems"
        (completeMethod)="onSearch($event)" 
        (onSelect)="onSelect($event)"
        (onKeyUp)="onKeyUp($event)"
        (onShow)="addPanelClass('items-container')"
        [dropdown]="showDropdownButton">
        <ng-template let-item pTemplate="item">
            <div class="dropdownitem">
                <div>{{item}}</div>
            </div>
        </ng-template>
    </p-autoComplete>
    <div *ngIf="loading" class="spinner-overlay"><i class="pi pi-spin pi-spinner"></i></div>
</div>

